import axios from '@axios'

const route = 'configuration/leave_types'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll() {
      return axios.get(route)
    },

    store(context, data) {
      return axios.post(route, data)
    },

    update(context, data) {
      return axios.put(`${route}/${data.id}`, data)
    },

    destroy(context, item) {
      return axios.delete(`${route}/${item.id}`)
    },
  },
}
